<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import RangeDatepicker from "@/components/global-themed/inputs/RangeDatepicker.vue";
import {ref} from "vue";
import {useKitActivityLogs} from "@/composables/kit-activity-logs/useKitActivityLogs";
import {axiosDownloadFile} from "@/composables/downloadFile";
import useWebsite from "@/composables/useWebsite";

const {websiteId} = useWebsite();
const {dateRange} = useKitActivityLogs();

const downloading = ref(false);

const downloadWebsiteChanges = async () => {
  downloading.value = true;
  await axiosDownloadFile(`/onsite-optimizer/export/csv/actions/${websiteId.value}`);
  downloading.value = false;
}
</script>

<template>
  <div class="tw-flex tw-justify-between tw-w-full">
    <RangeDatepicker
      :range="dateRange"
      @change="(newRange) => dateRange = newRange"
    />
    <div class="tw-flex tw-items-center tw-gap-4">
      <DefaultButton
        :loading="downloading"
        :disabled="downloading"
        variant="primary-inverted"
        @click="downloadWebsiteChanges"
      >
        <svg-vue
          icon="icons/browser"
          class="tw-w-6 tw-h-6 tw-mr-3"
        />
        Download All Website Changes
      </DefaultButton>

      <DefaultButton
        as="a"
        href="/local/business-profile"
        variant="primary-inverted"
      >
        <svg-vue
          icon="icons/business-location"
          class="tw-w-6 tw-h-6 tw-mr-3"
        />
        View GBP Listing
      </DefaultButton>
    </div>
  </div>
</template>

